export default __webpack_public_path__ + "static/media/florida.32341842.jpg";